import { Redirect, useLocalSearchParams } from 'expo-router';

export default function LearnLessonAlias() {
  const { slug } = useLocalSearchParams();
  const lesson = Array.isArray(slug) ? slug[0] : slug;
  return <Redirect href={lesson === 'index' ? '/learn' : `/learn/${lesson}`} />;
}
